import { Link } from "react-router-dom";

const INFO_LINKS = [
  { label: "About Us", to: "/pages/about-us" },
  { label: "Contact", to: "/pages/contact" },
  { label: "Shipping and Delivery", to: "/pages/shipping-delivery" },
  { label: "Returns and Refunds", to: "/pages/returns-refunds" },
  { label: "Privacy Policy", to: "/pages/privacy-policy" },
  { label: "Terms and Conditions", to: "/pages/terms-conditions" },
];

const Footer = () => (
  <footer data-testid="site-footer" className="bg-espresso text-cream">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-4 py-14 sm:px-8 md:flex-row md:items-start md:justify-between lg:px-16 lg:py-16">
      <div className="max-w-sm">
        <p className="font-accent text-2xl font-bold tracking-[0.35em]">AARMIRA</p>
        <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.3em] text-gold">
          Fashion &amp; Fortune
        </p>
        <p className="mt-6 text-sm leading-relaxed text-cream/60">
          Gemstone jewellery hand-crafted in India — where every cut stone is set to carry
          light, luck and legacy.
        </p>
      </div>
      <nav data-testid="footer-info-links">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold-muted">
          Information
        </p>
        <ul className="mt-5 space-y-3">
          {INFO_LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                className="text-sm text-cream/70 transition-colors duration-300 hover:text-gold"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
    <div className="border-t border-cream/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 sm:flex-row sm:px-8 lg:px-16">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-cream/40">
          © 2026 Aarmira — Fashion and Fortune
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-cream/40">
          Secure checkout by Razorpay
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
